import axios from "axios";

const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}`;

/**
 * 인사이트 리스트 전부 가져오기
 * @param param
 * offset, pageSize
 * @returns {Promise<never>}
 */
const readAllInsight = async (param) => {
  const { data } = await axios.get(`${baseUrl}/insight/read/all`, {
    params: param,
  });
  return data;
};

/**
 * 인사이트 글 작성하기
 * @param param
 * positive, category, category_name, important, content, created_by
 * @returns {Promise<*>}
 */
const createInsight = async (param) => {
  const { data } = await axios.post(`${baseUrl}/insight/create`, param);
  return data;
};

/**
 * 인사이트 글 수정하기
 * @param param
 * id, positive, category, category_name, important, content
 * @returns {Promise<*>}
 */
const editInsight = async (param) => {
  const { data } = await axios.post(`${baseUrl}/insight/update`, param);
  return data;
};

/**
 * 인사이트 글 삭제
 * @param param
 * insightIdList, updated_by
 * @returns {Promise<*>}
 */
const deleteInsight = async (param) => {
  const { data } = await axios.post(`${baseUrl}/insight/delete`, param);
  return data;
};

const insightApi = {
  readAllInsight,
  createInsight,
  editInsight,
  deleteInsight,
};

export default insightApi;
